import utils from 'utils';

import {useLabel} from '@/hooks/export';

import categoryImg1 from '@img/cat_1_VZV.png';

export const MachinePartSelect = (props: {
    onPartSelect: (partName: string) => void,
}) => {
    const label = useLabel();

    const purposeOptions = [
        {value: 'frontWheel', label: label.frontWheel},
        {value: 'backWheel', label: label.backWheel},
        {value: 'label', label: label.label},
        {value: 'whole', label: label.whole},
    ];

    return <div className={cmpClass}>
        <div className={classMap.wrapper}>
            <img src={categoryImg1}/>
            <div className={classMap.links}>
                {
                    purposeOptions
                        .filter((purpose) => !!purpose.value)
                        .map((purpose, i) => {
                            const linkClass = 'link' + purpose.value.charAt(0).toUpperCase() + purpose.value.slice(1);

                            return <div
                                className={classMap.link + ' ' + classMap[linkClass]}
                                key={i}
                            >
                                <i
                                    className={'iconfas-upload'}
                                    onClick={() => props.onPartSelect(purpose.value)}
                                ></i>
                                <span>{purpose.label}</span>
                            </div>;
                        })
                }
            </div>
        </div>
    </div>;
}

const cmpClass = 'machine-part-select';
const classMap = utils.generateClassMap(cmpClass, {
    wrapper: 'wrapper',
    link: 'link',
    links: 'links',

    // fixme: dehardcode
    linkFrontWheel: 'link--front-wheel',
    linkBackWheel: 'link--back-wheel',
    linkLabel: 'link--label',
    linkWhole: 'link--whole',
});
